export enum EOrderMetaStatus {
  REQUIRED_DOCUMENTS_NOT_UPLOAD = 'REQUIRED_DOCUMENTS_NOT_UPLOAD',
  REQUEST_FIELDS_REQUIRED = 'REQUEST_FIELDS_REQUIRED',
  DIFFERENT_REGION_IN_ITEMS = 'DIFFERENT_REGION_IN_ITEMS',
  ORDER_CHANGED = 'ORDER_CHANGED',
}
